import { render, staticRenderFns } from "./accreditor-list.vue?vue&type=template&id=0c490552&"
import script from "./accreditor-list.vue?vue&type=script&lang=js&"
export * from "./accreditor-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports